import { uniq } from "lodash";
import { getAppConfigSetting } from "../utils";

export const ROUTER_BASENAME = "fileStorage";
export const LEGIT_SERVICE_CONFIG = {
  useSessionLogin: false,
  apiUrl: getAppConfigSetting("legitApiUrl"),
};

export const FILE_STORAGE_API_HOST = getAppConfigSetting(
  "fileStorageApiUrl",
  "http://localhost"
);

export const FILE_STORAGE_API_ENDPOINT = `${FILE_STORAGE_API_HOST}/api/v1/applications`;

export enum AuthPermission {
  FileStorageAdmin = "filestorage.admin",
}

export const ALL_REQUESTED_PERMISSIONS: string[] = uniq([
  AuthPermission.FileStorageAdmin,
]);

export enum ApexLegitAuthorization {
  Loading = "APEX_LEGIT_AUTHORIZATION/LOADING",
  NotAsked = "APEX_LEGIT_AUTHORIZATION/NOT_ASKED",
  Success = "APEX_LEGIT_AUTHORIZATION/SUCCESS",
}

export const AUTH_LOADING_STATE = [
  ApexLegitAuthorization.Loading,
  ApexLegitAuthorization.NotAsked,
];

export const HOST = window.location.host;
export const SCOPES = "openid profile email";

export const SUPPORT_EMAIL = " (abateam@apexfintechsolutions.com)";

export const CONFIG_TABLE_COLUMNS = [
  "Action",
  "Name",
  "Config Version",
  "Pubsub topic",
  "Bucket name",
  "Accepted mime types",
  "Max file size",
  "Write permission",
  "Read permission",
  "Created At",
  "Updated At",
  "Updated By",
  "Deleted",
  "Deleted By",
  "Status",
];

export const MIME_TYPES = [
  { key: "csv", text: "csv", value: "csv" },
  { key: "doc", text: "doc", value: "doc" },
  { key: "docx", text: "docx", value: "docx" },
  { key: "gif", text: "gif", value: "gif" },
  { key: "jpeg", text: "jpeg", value: "jpeg" },
  { key: "jpg", text: "jpg", value: "jpg" },
  { key: "json", text: "json", value: "json" },
  { key: "pdf", text: "pdf", value: "pdf" },
  { key: "png", text: "png", value: "png" },
  { key: "svg", text: "svg", value: "svg" },
  { key: "xml", text: "xml", value: "xml" },
];

export const INITIAL_CONFIG_STATE = {
  accepted_mime_types: "",
  pubsub_topic: "",
  max_file_size: "",
  read_permission: "",
  write_permission: "",
  bucket_name: "",
};

export enum ConfigStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

// eslint-disable-next-line no-useless-escape
export const SPECIAL_CHARACTERS = /[ `!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/;
